export default class UserType {
    static Lime: string = 'Lime';
    static Insurer: string = 'Insurer';
    static Customer: string = 'Customer';
    static Organisation: string = 'Organisation';
}